export const environment = {
  API_URL: "http://api.mynvoice.ensolvers.com",
  GOOGLE_RECAPTCHA_URL: "6LfVrosaAAAAAImHhaWmnHjQKBoLupfHuGuO36g7",
};
